import React, { useEffect, useState } from 'react';
import ParamControl from './ParamControl';
import InputPreviewDialog from './InputPreviewDialog';

// Inspector: edits the parameters of the selected node. Without a selection
// it explains the workflow itself.
export default function Inspector({ node, meta, context, inputPreview, onParamsChange, onDelete }) {
  const [showInput, setShowInput] = useState(false);

  // Closing the dialog (or switching nodes) resets the toggle so the dialog
  // never auto-opens for the next selection.
  useEffect(() => {
    setShowInput(false);
  }, [node?.id]);

  if (!node) {
    return (
      <div className="flow-inspector flow-inspector-empty">
        <h2 className="flow-panel-title">Inspector</h2>
        <p className="flow-inspector-hint">
          Select a node to edit its parameters, or add one from the palette. Connect nodes by
          dragging from the dot on the right of a node to the next one.
        </p>
      </div>
    );
  }

  const params = node.params || {};
  const change = (key, value) => onParamsChange({ ...params, [key]: value });

  return (
    <div className="flow-inspector">
      <h2 className="flow-panel-title">{meta ? meta.name : node.type}</h2>
      {meta && <p className="flow-inspector-hint">{meta.description}</p>}

      {/* Input preview opens in a dialog */}
      {inputPreview && inputPreview.rows.length > 0 && (
        <div className="flow-input-section">
          <button
            type="button"
            className="flow-input-toggle"
            aria-expanded={showInput}
            onClick={() => setShowInput(!showInput)}
          >
            <span className="flow-input-toggle-icon">{showInput ? '▾' : '▸'}</span>
            <span>
              Input ({inputPreview.rows.length} rows, {inputPreview.fields.length} fields)
            </span>
          </button>
        </div>
      )}
      {showInput && inputPreview && (
        <InputPreviewDialog
          fields={inputPreview.fields}
          rows={inputPreview.rows}
          onClose={() => setShowInput(false)}
        />
      )}

      {/* Parameters */}
      {((meta && meta.params) || []).map((param) => (
        <ParamControl
          key={param.key}
          param={param}
          value={params[param.key]}
          context={{ ...context, chartType: params.chartType }}
          onChange={(value) => change(param.key, value)}
        />
      ))}
      <button type="button" className="btn btn-secondary flow-inspector-delete" onClick={onDelete}>
        Delete node
      </button>
    </div>
  );
}
